import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { t } from 'i18next'
import Navigation from 'Components/Navigation'
import useValidatePermission from 'Hooks/useValidatePermission'
import { VAPermissions, ROUTES } from 'Utils/constants'
import '../QuickListInformation/QuickListInformation.css'
import QuickListCatalog from './QuickListCatalog'

export default function QuickListCatalogPage() {
  const hasQuickListSettingsPermission = useValidatePermission(
    VAPermissions.settingsQuickList
  )
  const { id } = useParams()

  if (!hasQuickListSettingsPermission) {
    return <Redirect to={ROUTES.home} />
  }

  return (
    <>
      <Navigation />
      <div className="quick-list-information-container">
        <h1 data-testid="title-product-catalog">
          {t('QUICK_LIST_CATALOG.TITLE')}
        </h1>
        <QuickListCatalog id={id} />
      </div>
    </>
  )
}
